<template>
    <v-card>
        <v-card-title>
            <span>{{ title }}</span>
        </v-card-title>
        <v-card-subtitle v-if="!!courierinfo && isEditing">
            <span>Courier ID: {{ courierinfo.id }}</span>
        </v-card-subtitle>
        <v-divider />
        <v-card-text>
            <v-form ref="form" v-model="isValid">
                <p>Courier details</p>
                <v-text-field
                    filled
                    label="Username *"
                    prepend-inner-icon="mdi-account-key"
                    v-if="courierinfo.user"
                    v-model="courierinfo.user.username"
                    v-bind:rules="validation.required"
                ></v-text-field>
                <v-text-field
                    filled
                    label="Password *"
                    prepend-inner-icon="mdi-lock"
                    v-if="courierinfo.user && !isEditing"
                    v-model="courierinfo.user.password"
                    v-bind:rules="validation.required"
                    v-bind:type="shouldShowPassword ? 'text' : 'password'"
                    v-bind:append-icon="
                        shouldShowPassword ? 'mdi-eye-off' : 'mdi-eye'
                    "
                    v-on:click:append="
                        () => (shouldShowPassword = !shouldShowPassword)
                    "
                ></v-text-field>
                <v-text-field
                    filled
                    label="Confirm password *"
                    prepend-inner-icon="mdi-lock"
                    v-if="courierinfo.user && !isEditing"
                    v-model="courierinfo.user.password_confirmation"
                    v-bind:rules="[
                        ...validation.required,
                        ...validation.confirmMatch
                    ]"
                    v-bind:type="shouldShowPassword ? 'text' : 'password'"
                    v-bind:append-icon="
                        shouldShowPassword ? 'mdi-eye-off' : 'mdi-eye'
                    "
                    v-on:click:append="
                        () => (shouldShowPassword = !shouldShowPassword)
                    "
                ></v-text-field>
                <v-text-field
                    filled
                    label="Name *"
                    prepend-inner-icon="mdi-account"
                    v-if="courierinfo.user"
                    v-model="courierinfo.user.name"
                    v-bind:rules="validation.required"
                ></v-text-field>
                <v-text-field
                    filled
                    type="number"
                    label="Phone *"
                    prepend-inner-icon="mdi-phone"
                    v-if="courierinfo.user"
                    v-model.number="courierinfo.user.phone"
                    v-bind:rules="validation.required"
                ></v-text-field>
                <p>Extra details</p>
                <date-picker-input
                    label="Date of birth"
                    v-model="courierinfo.date_of_birth"
                />
                <v-text-field
                    filled
                    label="Address"
                    prepend-inner-icon="mdi-map-marker"
                    v-model="courierinfo.address"
                ></v-text-field>
                <v-text-field
                    filled
                    label="Emergency contact"
                    prepend-inner-icon="mdi-medical-bag"
                    v-model="courierinfo.emergency_contact"
                ></v-text-field>
                <date-picker-input
                    label="Joining date"
                    v-model="courierinfo.joining_date"
                />
                <date-picker-input
                    label="Leaving date"
                    v-model="courierinfo.leaving_date"
                />
            </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
            <v-btn
                tile
                class="mx-2"
                v-on:click="$emit('cancel')"
                v-bind:disabled="$store.state.app.loading"
                >Cancel</v-btn
            >
            <v-spacer />
            <v-btn
                tile
                color="primary"
                class="mx-2"
                v-on:click="submit"
                v-bind:loading="$store.state.app.loading"
                >Submit</v-btn
            >
        </v-card-actions>
    </v-card>
</template>

<script>
import snackbar from '@/utils/snackbar';

export default {
    components: {
        'date-picker-input': () => import('@/components/DatePickerInput.vue')
    },
    props: {
        courierinfo: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            default: 'Courier form'
        },
        // Differentiate edit and create
        isEditing: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isValid: null,
            shouldShowPassword: false,
            validation: {
                required: [v => !!v || 'The field is required'],
                confirmMatch: [
                    v =>
                        v == this.courierinfo.user.password ||
                        'The password does not match'
                ]
            }
        };
    },
    methods: {
        submit() {
            if (this.isValid) {
                this.$emit('submit');
            } else {
                this.$refs.form.validate();
                snackbar.show('Please check the fields.', 'warning');
            }
        }
    }
};
</script>

<style scoped>
/* Remove stepper on v-text-field type number */
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>
